import { useIsomorphicLayoutEffect } from "@/hooks/use-isomorphic-layout-effect"

import { hasObtrusiveScrollbars } from "@/lib/has-obtrusive-scrollbars"

export function ObtrusiveScrollbarTest() {
  useIsomorphicLayoutEffect(() => {
    if (hasObtrusiveScrollbars()) {
      document.documentElement.classList.add("layout-scrollbar-obtrusive")
    }
  }, [])

  return null
}
